export default __webpack_public_path__ + "static/media/Membership_Icon.fae4be55.svg";